import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

export default getDiscoveryKPIURL;

/**
 * This URL constructor creates an URL for discovery.
 * @param {object} args URL constructor arguments
 * @param {array} args.countryIds Array of country id's to retrieve data for, if omitted data should be returned as broken down (split out) to each country separately
 * @param {boolean} args.download When this parameter is supplied as true the API returns a plain-text csv.
 * @param {array} args.entityIds Array of entity id's to retrieve data for
 * @param {('track'|'artist')} args.entityType Entity type that supports showing data for discovery
 * @returns {string} Discovery URL for tracks and artists
 */

interface IProps {
  countryIds?: any;
  download?: boolean;
  entityIds: string;
  entityType: 'track' | 'artist';
  region?: string;
  compareMode?: string;
  customRegion?: string | string[];
}

function getDiscoveryKPIURL(args: IProps): string {
  const {
    countryIds,
    download,
    entityIds,
    entityType,
    region,
    compareMode,
    customRegion,
  } = args;

  const apiEntityType = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/discoveries/kpi/${apiEntityType}/${entityIds}${
    params !== '' ? `?${params}` : ''
  }`;
}
